import "./styles/base.css";
import "./styles/animations.css";
import { useState, useEffect } from "react";
import ChatButton from "./components/ChatButton";
import ChatPanel from "./components/ChatPanel";
import ChatbotMain from "./components/ChatbotMain";
import DeactiveButton from "./components/DeactiveButton";
import ErrorSnackbar from "./components/ErrorSnackbar";
import { initializeTheme } from "./theme";
import { fetchChatbotConfig } from "./api/chat.api";
import { getChatbotPosition, isSmartPhone } from "./utils/utils";
import { DEFAULT_DESIGN, DEFAULT_CONFIG } from "./constants/const";
import { useErrorStore } from "./store/error.store";

function App() {
  const [open, setOpen] = useState(false);
  const [isMaximized, setIsMaximized] = useState(isSmartPhone());
  const [themeInitialized, setThemeInitialized] = useState(false);
  const [deactiveMode, setDeactiveMode] = useState(false);
  const [deactiveMessage, setDeactiveMessage] = useState("");
  const { setError } = useErrorStore();

  useEffect(() => {
    (async () => {
      try {
        const res = await fetchChatbotConfig();
        if (res?.success && res.data?.design) {
          initializeTheme(res.data.design, res.data.config);
          setThemeInitialized(true);
          return;
        } else {
          if (res?.success === false && res?.error === "SUBSCRIPTION_INVALID") {
            setDeactiveMode(true);
            setDeactiveMessage(res?.message || "");
            setThemeInitialized(true);
            return;
          }
        }
      } catch {
        console.info(
          "バックエンドテーマ設定取得失敗、デフォルトテーマを使用する"
        );
        setDeactiveMode(true);
        setDeactiveMessage(
          "現在、こちらのチャットボットはご利用いただけません。"
        );
        setThemeInitialized(true);
        return;
      }
      // デフォルトテーマ
      initializeTheme(DEFAULT_DESIGN, DEFAULT_CONFIG);
      setThemeInitialized(true);
    })();
  }, []);

  const { position: leftOrRight, offset_x, offset_y } = getChatbotPosition();

  const toggleChat = () => {
    if (!open) {
      setOpen(true);
      if (isSmartPhone()) {
        setIsMaximized(true);
      }
    }
  };

  const closeChat = () => {
    setOpen(false);
  };

  const toggleMaximize = () => {
    if (!isSmartPhone()) {
      setIsMaximized((prev) => !prev);
    }
  };

  const toggleDeactiveChat = () => {
    setError(deactiveMessage);
  };

  if (!themeInitialized) {
    return null;
  }

  if (deactiveMode) {
    return (
      <>
        <DeactiveButton onClick={toggleDeactiveChat} />
        <ErrorSnackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          sx={{ bottom: "100px", right: "20px" }}
        />
      </>
    );
  }

  return (
    <>
      <ChatPanel
        open={open}
        isMaximized={isMaximized}
        leftOrRight={leftOrRight}
        offset_x={Number(offset_x) + 4}
        offset_y={0}
      >
        <ChatbotMain
          isMaximized={isMaximized}
          onToggleMaximize={toggleMaximize}
          onChatClose={closeChat}
        />
      </ChatPanel>
      <ChatButton
        leftOrRight={leftOrRight}
        offset_x={Number(offset_x)}
        offset_y={Number(offset_y)}
        onClick={toggleChat}
        isOpen={open}
      />
    </>
  );
}

export default App;
